import React, {useState, useEffect} from "react";
import {Route, Routes, useNavigate} from "react-router-dom";
import Auth from "../Auth/Auth";
import Reg from "../Reg/Reg";
import MainPage from "../MainPage/MainPage";
import ProfileUser from "../ProfileUser/ProfileUser";
import axios, {
    LOGIN_URL,
    DICTIONARY_COUNTRIES_GET_LIST,
    DICTIONARY_VESSELS_GET_LIST,
    DICTIONARY_ORGANIZATIONS_GET_LIST,
    DICTIONARY_PORTS_GET_LIST,
    DICTIONARY_CITIES_GET_LIST, USER_GET_CAPTAINS,
    DICTIONARY_CONSIGNEE_GET_LIST
} from "../../Api/axios";
import NoPageFound from "../NoPageFound/NoPageFound";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import RequireAuth from "../RequireAuth/RequireAuth";
import Layout from "../Layout/Layout";
import useAxiosPrivate from "../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";
import {axiosGetRequest} from "../../Api/axiosGetRequest";

function App() {

    const navigate = useNavigate();
    const [authError, setAuthError] = useState('');
    // const location = useLocation();
    // // const fromMainPage = location.state?.from?.pathname || "/";

    const axiosPrivate = useAxiosPrivate();
    const { isLoggedIn,
            setAuth,
            setLoggedIn,
            setDictionaryCountries,
            setDictionaryCities,
            setDictionaryOrg,
            setDictionaryPorts,
            setDictionaryVessels,
            setDictionaryCaptains,
            setDictionaryConsignee,
            stateReducer
    } = useAuth();

    const handleLogin = async (login, password) => {
        try {
            const response = await axios.post(LOGIN_URL,
                JSON.stringify({login, password}),
                {
                    headers: {'Content-Type' : 'application/json'}
                }
            );
            const accessToken = response?.data?.accessToken;
            const refreshToken = response?.data?.refreshToken;
            const roles = response?.data?.user?.roles;
            const user = response?.data?.user
                setAuth({login, password, roles, accessToken, refreshToken, user})
                setAuthError('');
                setLoggedIn(true);
                navigate('/', { replace: true });
        } catch (err) {
            if (!err?.response) {
                setAuthError('Server not responding');
            } else if (err.response?.status === 400) {
                setAuthError('Incorrect login or password');
            } else if (err.response?.status === 401) {
                setAuthError('User not authorized')
            } else {
                setAuthError('Login failed')
            }
        }
    }

    useEffect(() => {
        if (isLoggedIn === true) {
            let isLoading = true;

            const controller = new AbortController();

            axiosGetRequest(axiosPrivate, DICTIONARY_COUNTRIES_GET_LIST, controller, isLoading, setDictionaryCountries);
            axiosGetRequest(axiosPrivate, DICTIONARY_ORGANIZATIONS_GET_LIST, controller, isLoading, setDictionaryOrg);
            axiosGetRequest(axiosPrivate, DICTIONARY_VESSELS_GET_LIST, controller, isLoading, setDictionaryVessels);
            axiosGetRequest(axiosPrivate, DICTIONARY_PORTS_GET_LIST, controller, isLoading, setDictionaryPorts);
            axiosGetRequest(axiosPrivate, DICTIONARY_CITIES_GET_LIST, controller, isLoading, setDictionaryCities);
            axiosGetRequest(axiosPrivate, USER_GET_CAPTAINS, controller, isLoading, setDictionaryCaptains);
            axiosGetRequest(axiosPrivate, DICTIONARY_CONSIGNEE_GET_LIST, controller, isLoading, setDictionaryConsignee);

            return () => {
                isLoading = false;
                isLoading && controller.abort()
            }
        }
    }, [isLoggedIn, stateReducer.updateRequestDictionary])

  return (
            <Routes>
                <Route path={'/'} element={<Layout/>}>
                    <Route path={'/auth'} element={<Auth
                        authError={authError}
                        setAuthError={setAuthError}
                        handleLogin={handleLogin}
                    />}/>
                    <Route path={'/reg'} element={<Reg/>}/>
                        <Route element={<RequireAuth/>}>
                            <Route path={'/'} element={<MainPage/>}/>
                            <Route path={'/profile'} element={<ProfileUser/>}/>
                            <Route path={'*'} element={<NoPageFound
                                isLoggedIn={isLoggedIn}
                            />}/>
                        </Route>
                </Route>
            </Routes>
      );
}
export default App;
